import React from 'react'
import {  makeStyles, Button, Grid} from '@material-ui/core'
import {Link} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems:'center',
        [theme.breakpoints.down('sm')]:{
            
            marginTop:'30px'
        }
        // backgroundColor:'red'
    },
    sectionHeading: {
        fontSize: '64px',
        fontWeight: 600,
        letterSpacing: 0.1,
        margin: '0 20px',
        lineHeight: '60px',
        [theme.breakpoints.down('md')]:{
            fontSize: '54px',
        },
        [theme.breakpoints.down('sm')]:{
            fontSize: '45px',
            lineHeight: '40px',
            marginTop:'30px'
        }
    },
    authorDesc:{
        width: '90%',
        maxWidth: '600px',
        [theme.breakpoints.down('sm')]:{
            textAlign:'center'
        }
    },
    exploreBtn:{
        color: 'black',
        marginLeft: '20px',
        boxShadow: 'none',
        borderRadius: 2,
        padding: '10px 75px',
        margin: '20px 0',
        '&:hover':{
            color: theme.palette.secondary.light
        }
    }
}))

function AboutAuthor() {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <Grid container style={{width: '100%'}} spacing={0} alignItems= 'center'>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <img src="./assets/images/about.png" alt="About_Author_Image" style={{width: '100%'}} />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div style={{maxWidth:'600px'}} className={classes.authorDesc}>
                        <h2 className={classes.sectionHeading}>About the Author</h2>
                        <p style={{marginLeft:'20px'}}>Interactively provide access to clicks-and-mortar paradigms vis-a-vis excellent relationships. Rapidiously engage</p>
                        <p style={{marginLeft:'20px'}}>customer directed data with enterprise architectures. Appropriately build covalent outsourcing through timely niche markets. Intrinsicly pursue proactive intellectual capital after cross-</p>
                        <Link to="/shop" style={{textDecoration:'none'}}>
                            <Button color="primary" variant="contained" className={classes.exploreBtn} >EXPLORE</Button>
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default AboutAuthor
